import { PricingFormBody } from './PricingFormBody';

export function PricingFormSection() {
  return (
    <div className="flex flex-col gap-y-2">
      <PricingFormBody />
    </div>
  );
}
